import { useEffect } from 'react'

/**
 * Custom Prompt component to replace React Router v5's Prompt
 * Uses browser's beforeunload event for navigation blocking
 * Note: In-app navigation blocking via useBlocker requires data router,
 * so we only handle browser refresh/close events
 */
const Prompt = ({ when, message }) => {
  // Handle browser navigation (refresh, close tab, etc.)
  useEffect(() => {
    const handleBeforeUnload = event => {
      if (when) {
        event.preventDefault()
        event.returnValue = message
        return message
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [when, message])

  return null
}

export default Prompt
